<template>
  <main>
    <div class="sentence">
      <img src="./../assets/logo/Grupo 92.svg" width="35%" alt="osfatun" />
    </div>
    <section class="content">
      <h3 class="title mb-5 has-text-centered">
        ¡Hola {{ this.$store.state.name }}!
      </h3>

    

      <div >
        <h5 class="title mb-5 has-text-centered">
          Su carga ha sido presentada exitosamente.
        </h5>
        <img src="../assets/gracias.png" alt="" />


       
        <router-link to="/new_invoice" class="create">
          <b-button
          class="button-new"
            style="display: flex;"
            type="is-success"
            :disabled="loading"
          >
            <img src="../assets/circle-plus 1.png" alt="" />Cargar Nueva Factura
          </b-button>
        </router-link>
        
      </div>
    </section>
    <Footer>
      <p class="m-2">Desarrollado por</p>
      <img src="../assets/logo/logozaro1.svg" alt="zaro" />
    </Footer>
  </main>
</template>

<script>

import { mapMutations } from "vuex";

export default {
  data() {
    return {
      isFullPage: true,
      files: [],
      documentoAfiliado: "",
      numeroOrden: "",
      cantidad: "",
      importePractica: "",
      codigoPractica: "",
      cargado: false,
      loading: false,
      baseUrl: "https://api.osfatun.com.ar/",
      fileInputs: [],
    };
  },

  computed: {
   
  },
  // ...
  methods: {
   

  

    ...mapMutations(["setToken", "setName", "setIdInvoice"]),
  },
};
</script>

<style>
.login-card {
  max-width: 400px; /* Ajusta el ancho del b-card */
}
</style>
<style scoped>
.sentence {
  background-image: url("./../assets/fondo.png");
  background-size: 100%;
  width: 100%;
  background-repeat: no-repeat;
  max-height: 33vh;
  padding: 2em;
}
.sentence img {
  padding: 1em;
  width: 220px;
  margin: 0 auto;
  text-align: center;
  display: block; 
}
.content {
  position: relative;
  max-width: 40%;
  padding: 40px 30px;
  margin: 0 auto;
}
h3.title {
  font-weight: bold;
  font-size: 34px;
  color: #00758f;
  line-height: 1.9rem;
  margin: 0 50px;
}
.inputs-container {
  display: flex;
  min-width: 300px;
  min-height: 280px;
  padding-bottom: 0px;
  flex-direction: column;
  justify-content: center;
}
.custom-input :placeholder-shown {
  color: black;
  background: rgb(228, 227, 227);
  border: 1px solid #bdbdbd;
}

.button-charge{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
    padding: 10px 20px;
}
.button-charge img{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
}

.control {
  padding: 5px;
}
.second-container {
  max-width: 90%;
  margin: 0 auto;
}
.hr {
  background-color: #eeeeee;
  margin: 50px 0;
}
h5.title {
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 6%;
}
.file-upload img {
  padding-bottom: 1em;
}
.file-upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.button {
  background: rgba(0, 117, 143, 1);
}
.button text {
  padding-bottom: 100px;
  background: rgba(0, 117, 143, 1);
}
.create {
  display: flex; /* Usamos flexbox para alinear elementos internos */
  justify-content: center;
  padding: 1px;
}
.create p {
  display: flex; /* Usamos flexbox para alinear elementos internos */
  justify-content: center;
  padding: 1px;
}
.button-new{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
    padding: 10px 20px;
}
.button-new img{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
}

footer {
  display: flex;
  justify-content: center;
  margin-bottom: 1em;
  margin-top: 15em;
}



@media screen and (max-width: 42em) {
  .sentence {
    max-height: 15vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 3em;
  }
  
.sentence img {
    width: 35%;
    position: relative;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
    top: 45%;
    left: 15%;
    display: block;
   
  }

  .content {
    position: relative;
    background: white;
    max-width: 95%;
    padding: 40px 20px;
    margin: 1em auto;
  }
  
  h3.title {
    font-size: 29px;
    margin: 0;
  }
  h5.title{
    font-size: 15px;
  }
  .cont-h3 {
    margin: 0 2em;
  }
  footer {
    margin-top: 12em auto;
  }
}
</style>
